// BUTANI nav link fixer - rewrites placeholder # links to real pages
(function() {
  var map = {
    'jewellery': '/pages/jewellery-rings',
    'bridal': '/pages/bridal',
    'news': '/pages/news',
    'high jewellery': '/pages/high-jewellery',
    'the house': '/pages/the-house',
    'points of sale': '/pages/points-of-sale'
  };
  function fix() {
    var links = document.querySelectorAll('#shopify-section-header a, nav a, header a');
    links.forEach(function(a) {
      var href = (a.getAttribute('href') || '').trim();
      if (href === '#') {
        var text = (a.textContent || '').trim().toLowerCase();
        if (map[text]) {
          a.setAttribute('href', map[text]);
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }
  // Also run after a short delay in case of lazy rendering
  setTimeout(fix, 500);
  setTimeout(fix, 1500);
})();
